import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { portalReasonForError, redirectToPortal } from './portal-redirect';
import { NotificationService } from '../notifications/notification.service';

/**
 * Ответы 403 с кодом доступа: no-access / blocked / invalid-token — на портал единого входа;
 * no-rights (роль в сервисе не назначена) — заглушка /no-role. Остальные ошибки — дальше по цепочке.
 */
export const accessErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const notify = inject(NotificationService);

    return next(req).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 403) {
                const reason = portalReasonForError(error.error);
                if (reason === 'no-rights') {
                    void router.navigateByUrl('/no-role');
                } else if (error?.error?.code === 'forbidden') {
                    notify.error('Недостаточно прав');
                } else if (reason) {
                    redirectToPortal(reason);
                }

            }
            return throwError(() => error);
        }),
    );
};
